export function nl2br(str: string) {
  const breakTag = '<br />';

  return str
    .trim()
    .replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}
